var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.869329 10.0549C0.525065 10.3908 0.51804 10.9872 0.876355 11.3368C1.2417 11.6864 1.85294 11.6796 2.19018 11.3505L6.34945 7.29214L10.5017 11.3437C10.853 11.6864 11.4572 11.6864 11.8155 11.3368C12.1738 10.9803 12.1738 10.3976 11.8225 10.0549L7.6703 6.00333L11.8225 1.94494C12.1738 1.60217 12.1809 1.01261 11.8155 0.662984C11.4572 0.313359 10.853 0.313359 10.5017 0.656129L6.34945 4.70766L2.19018 0.656129C1.85294 0.320215 1.23467 0.306504 0.876355 0.662984C0.51804 1.01261 0.525065 1.61588 0.869329 1.94494L5.02157 6.00333L0.869329 10.0549Z",
    fill: "#D81F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmark);
export default __webpack_public_path__ + "static/media/xmark.6e374db6bc216f86373ef249d3587892.svg";
export { ForwardRef as ReactComponent };